import { Typography } from '@mui/material';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { CollaborationStepContainer } from 'features/collaboration-base/components';
import styled from 'features/theme/styled';
import theme from 'features/theme/theme';
import { Button } from 'features/ui/elements';

interface HandoffEndProps {
  onCancelHandoff: () => void;
  onCompleteHandoff?: () => void;
  isShowCompleteHandoffButton?: boolean;
  isLoading?: boolean;
}

export const HandoffEnd: FC<HandoffEndProps> = ({
  onCancelHandoff,
  onCompleteHandoff,
  isShowCompleteHandoffButton,
  isLoading = false,
}) => {
  const { t } = useTranslation('translation', {
    keyPrefix: 'teamHandoffEnd',
  });

  return (
    <CollaborationStepContainer testId='team-handoff-end'>
      <Typography variant='body1' color={theme.palette.grey[50]}>
        {t('title')}
      </Typography>
      <Typography variant='body2' color={theme.palette.common.white} mt={8}>
        {t('description')}
      </Typography>
      {isShowCompleteHandoffButton && (
        <CompleteHandoffButton
          fullWidth
          type='submit'
          color='primary'
          size='small'
          data-testid='complete-handoff-button'
          title={t('completeHandoff')}
          onClick={onCompleteHandoff}
          loading={isLoading}
        >
          {t('completeHandoff')}
        </CompleteHandoffButton>
      )}
      <CancelHandoffButton
        fullWidth
        color='secondary'
        size='small'
        data-testid='cancel-handoff-button'
        title={t('cancelHandoff')}
        onClick={onCancelHandoff}
        loading={isLoading}
      >
        {t('cancelHandoff')}
      </CancelHandoffButton>
    </CollaborationStepContainer>
  );
};

const CompleteHandoffButton = styled(Button)`
  margin-top: ${theme.spacing(8)};
`;

const CancelHandoffButton = styled(Button)`
  margin-top: ${theme.spacing(4)};
`;
